import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpErrorHandler } from '../../http/httpErrorHandler.service';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ICustomerAppsConfig } from '../../config/config.module';
import { ConfigService } from '../../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  constructor(
    private http: HttpClient,
    private httpErrorHandler: HttpErrorHandler,
    private configService: ConfigService<ICustomerAppsConfig>,
  ) {}

  requestReset(email: string): Observable<void> {
    return this.http
      .put<void>(`${this.configService.config.apiUrl}/password/request-reset`, { email })
      .pipe(catchError(this.httpErrorHandler.handleErrorCallback));
  }

  validateResetToken(token: string): Observable<void> {
    return this.http
      .put<void>(`${this.configService.config.apiUrl}/password/validate-reset-token`, { token })
      .pipe(catchError(this.httpErrorHandler.handleErrorCallback));
  }

  reset(token: string, password: string): Observable<void> {
    return this.http
      .put<void>(`${this.configService.config.apiUrl}/password/reset`, { token, password })
      .pipe(catchError(this.httpErrorHandler.handleErrorCallback));
  }
}
